<template>
    <el-row class="box-roles">
        <el-col :span="24">
            <InputField :label-text="$t('member.shareName')" is-required>
                <InputText classes="w-100" v-model="dataShare.shareName"> </InputText>
                <template #error v-if="errorShareName">{{ errorShareName }}</template>
            </InputField>
            <template v-if="!isEdit">
                <div class="mt-3">
                    <div class="form-group d-flex">
                        <label class="d-block mb-2 mr-4 cursor-pointer" for="selectMemberAll">
                            <input class="radio_animated cursor-pointer" id="selectMemberAll" v-model="typeSelectMember" :value="'multi'" type="radio" />
                            {{ $t('share.selectMulti') }}
                        </label>
                        <label class="d-block mb-2 cursor-pointer" for="selectMember">
                            <input class="radio_animated cursor-pointer" id="selectMember" v-model="typeSelectMember" :value="'all'" type="radio" />
                            {{ $t('share.selectAll') }}
                        </label>
                    </div>
                </div>
            </template>
            <template v-if="typeSelectMember === 'multi'">
                <InputField classes="mt-3" :label-text="$t('share.fullNameShare')" is-required>
                    <el-row class="items-share flex-column" v-for="(memberShare, indexItem) in listMemberShare" :key="indexItem" :gutter="20">
                        <el-col :span="23" :xl="14" :xs="24" :md="14">
                            <div class="d-flex flex-row">
                                <SelectCustom classes="w-100 mr-2" v-loading="isLoadingListMember" :isMulti="!isEdit" v-model="memberShare.member_id">
                                    <template #options>
                                        <el-option-group v-for="(company, indexC) in listMembers" :key="indexC + 'index'" :label="company.company">
                                            <el-option v-for="user in company.options" :key="user.id" :label="`${user.surname ?? ''} ${user.name ?? ''}`" :value="user.id"> </el-option>
                                        </el-option-group>
                                    </template>
                                </SelectCustom>
                                <i class="el-icon-remove icon-remote" v-if="listMemberShare.length > 1" @click="onDeleteMemberShare(indexItem)"></i>
                            </div>
                        </el-col>
                        <el-col :span="23" class="mb-2 mb-sm-0">
                            <div class="d-md-flex d-block align-items-center w-100 pl-0 mt-3">
                                <div class="mr-sm-3 mr-0 text-role">
                                    {{ $t('member.role') }}
                                    <span class="text-danger"> *</span>
                                </div>
                                <div class="list-roles">
                                    <label class="ckbox" v-for="roleItem in listRoles" :key="roleItem.type">
                                        <input :disabled="roleItem.value === 'detail'" v-model="memberShare.roles" type="checkbox" :value="roleItem.value" />
                                        <span>{{ $t(roleItem.label) }}</span>
                                    </label>
                                </div>
                            </div>
                            <span class="box-error-message" v-if="memberShare.msgRoleRequired">
                                {{ memberShare.msgRoleRequired }}
                            </span>
                        </el-col>
                    </el-row>
                </InputField>
                <InputField classes="mt-3" v-if="!isEdit">
                    <Button type="primary" @click="onAddMemberShare">
                        <el-icon class="el-icon-plus mr-2"></el-icon>
                        {{ $t('button.add') }}
                    </Button>
                </InputField>
            </template>
            <template v-else-if="typeSelectMember === 'all'">
                <InputField classes="mt-3" :label-text="$t('member.role')" is-required>
                    <div class="d-sm-flex d-block align-items-center w-100 pl-0 mt-2">
                        <div class="list-roles">
                            <label class="ckbox" v-for="roleItem in listRoles" :key="roleItem.type">
                                <input :disabled="roleItem.value === 'detail'" v-model="rolesFilter" type="checkbox" :value="roleItem.value" />
                                <span>{{ $t(roleItem.label) }}</span>
                            </label>
                        </div>
                    </div>
                </InputField>
            </template>
        </el-col>
    </el-row>
</template>
<script>
import SelectCustom from '@/components/partials/customs/SelectCustom';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import { TYPE_PLAN_READONLY } from '@/config/constants';
import { mapState } from 'vuex';

export default {
    name: 'form-filter',
    props: {
        listMembers: {
            type: Array,
            required: false,
            default: () => []
        },
        valueShare: {
            type: Object,
            required: true,
            default: () => {}
        },
        data: {
            type: Object,
            required: true,
            default: () => {}
        },
        isEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        isLoadingListMember: {
            type: Boolean,
            required: false,
            default: false
        },
        errorShareName: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        SelectCustom,
        InputField,
        InputText
    },
    data() {
        return {
            dataShare: this.data,
            typeSelectMember: 'multi',
            rolesFilter: ['detail'],
            listMemberShare: this.data.listMemberShare
        };
    },
    created() {},
    computed: {
        ...mapState('auth', ['userInfo']),
        listRoles() {
            if (this.userInfo.plan.type_plan === TYPE_PLAN_READONLY) {
                return [{ label: 'member.roles.view', value: 'detail' }];
            } else {
                return [
                    { label: 'member.roles.view', value: 'detail' },
                    { label: 'member.roles.edit', value: 'update' },
                    { label: 'member.roles.register', value: 'create' },
                    { label: 'member.roles.export', value: 'export' }
                ];
            }
        },
        watchMemberShareAndTypeSelect() {
            return [this.typeSelectMember, this.listMemberShare, this.rolesFilter];
        }
    },
    watch: {
        dataShare: {
            deep: true,
            handler(val) {
                this.$emit('update:data', this.dataShare);
            }
        },
        watchMemberShareAndTypeSelect: {
            deep: true,
            immediate: true,
            handler(val) {
                let valueShare = {};
                if (this.typeSelectMember === 'multi' && this.listMemberShare) {
                    this.listMemberShare.forEach((elm) => {
                        if (Array.isArray(elm.member_id) && elm.member_id.length > 0) {
                            elm.member_id.forEach((item) => {
                                valueShare[item] = {
                                    1: elm.roles.includes('detail'),
                                    2: elm.roles.includes('create'),
                                    3: elm.roles.includes('update'),
                                    4: elm.roles.includes('delete'),
                                    5: elm.roles.includes('export')
                                };
                            });
                        }
                    });
                } else if (this.typeSelectMember === 'all') {
                    let dataRole = {
                        1: this.rolesFilter.includes('detail'),
                        2: this.rolesFilter.includes('create'),
                        3: this.rolesFilter.includes('update'),
                        4: this.rolesFilter.includes('delete'),
                        5: this.rolesFilter.includes('export')
                    };
                    this.listMembers.forEach((elm) => {
                        if (elm.options.length > 0) {
                            elm.options.forEach((item) => {
                                valueShare[item.id] = dataRole;
                            });
                        }
                    });
                }
                this.$emit('update:valueShare', valueShare);
            }
        }
    },
    methods: {
        onAddMemberShare() {
            this.listMemberShare.push({
                member_id: [],
                roles: ['detail']
            });
        },
        onDeleteMemberShare(index) {
            this.listMemberShare.splice(index, 1);
        }
    }
};
</script>
